$(document).ready(function () {
    let slider = $('.organo-republic-slider');
    let currentMode = null;

    function initSlider() {
        let width = $(window).width();
        let isDesktopNow = width >= 1024;

        // Если режим не изменился и слайдер уже инициализирован - ничего не делаем
        if (currentMode === isDesktopNow && slider.hasClass('slick-initialized')) {
            return;
        }

        currentMode = isDesktopNow;

        // Уничтожаем текущий слайдер
        if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
        }

        // ДЕСКТОПНАЯ ВЕРСИЯ
        if (isDesktopNow) {
            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $('.organo-republic-review-slider-arrow.left'),
                nextArrow: $('.organo-republic-review-slider-arrow.right'),
                infinite: false,
                adaptiveHeight: true,
                fade: true,
                cssEase: 'linear',
                speed: 300,
                draggable: false,
                swipe: false
            });
        } 
        // МОБИЛЬНАЯ ВЕРСИЯ
        else {
            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                adaptiveHeight: true,
                variableWidth: true,
                
                // Оптимальные настройки для свайпа
                draggable: true,
                swipe: true,
                touchThreshold: 10,
                touchMove: true,
                waitForAnimate: true,
                swipeToSlide: true,
                
                // Дополнительные настройки
                edgeFriction: 0.35,
                speed: 300
            });
            
            // Добавляем обработчики touch-событий вручную
            setupMobileTouchEvents();
        }
    }

    function setupMobileTouchEvents() {
        let startX = 0;
        let currentX = 0;
        let isSwiping = false;
        let sliderElement = slider[0];
        
        if (!sliderElement) return;
        
        sliderElement.addEventListener('touchstart', function(e) {
            startX = e.touches[0].clientX;
            currentX = startX;
            isSwiping = true;
        }, { passive: true });
        
        sliderElement.addEventListener('touchmove', function(e) {
            if (!isSwiping) return;
            currentX = e.touches[0].clientX;
            
            // Предотвращаем скролл страницы при горизонтальном свайпе
            let diffX = startX - currentX;
            if (Math.abs(diffX) > Math.abs(e.touches[0].clientY - startX)) {
                e.preventDefault();
            }
        }, { passive: false });
        
        sliderElement.addEventListener('touchend', function(e) {
            if (!isSwiping) return;
            
            let diffX = startX - currentX;
            let threshold = 50; // Минимальное расстояние для смены слайда
            
            if (Math.abs(diffX) > threshold) {
                if (diffX > 0) {
                    // Свайп влево - следующий слайд
                    slider.slick('slickNext');
                } else {
                    // Свайп вправо - предыдущий слайд
                    slider.slick('slickPrev');
                }
            }
            
            isSwiping = false;
        }, { passive: true });
    }

    // Инициализация при загрузке
    initSlider();

    // adaptiveHeight замеряет слайд при инициализации; видео добирает высоту позже —
    // пересчитываем позицию, когда у видео появились метаданные
    function remeasure() {
        if (slider.hasClass('slick-initialized')) {
            slider.slick('setPosition');
        }
    }
    document.querySelectorAll('.organo-republic-slider video').forEach(function (v) {
        if (v.readyState >= 1) {
            remeasure();
        } else {
            v.addEventListener('loadedmetadata', remeasure);
        }
    });

    // Перезапуск при ресайзе
    let resizeTimer;
    $(window).on('resize orientationchange', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initSlider, 150);
    });
});